module.exports = __webpack_public_path__ + "img/ia.58786252.jpg";